import { render } from "./AppSidebar.vue?vue&type=template&id=ea3cc0fa&scoped=true&ts=true"
import script from "./AppSidebar.vue?vue&type=script&lang=ts"
export * from "./AppSidebar.vue?vue&type=script&lang=ts"

import "./AppSidebar.vue?vue&type=style&index=0&id=ea3cc0fa&scoped=true&lang=css"
import "./AppSidebar.vue?vue&type=style&index=1&id=ea3cc0fa&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea3cc0fa"]])

export default __exports__